import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Directive,
} from "@angular/core";
import { ROUTES } from "../.././sidebar/sidebar.component";
import {
  Router,
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
} from "@angular/router";
import {
  Location,
  LocationStrategy,
  PathLocationStrategy,
} from "@angular/common";
import { Subscription } from "rxjs/Subscription";
import { CortesService } from '../../servicios/cortes.service';
import { Cortes, CatSucursales, CatUsuarios } from '../../entidades/entidades';
import { CatSucursalService } from "../../servicios/cat-sucursal.service";
import { CatUsuariosService } from "../../servicios/cat-usuarios.service";
import { AuthenticationService } from "app/servicios";

var misc: any = {
  navbar_menu_visible: 0,
  active_collapse: true,
  disabled_collapse_init: 0,
};

@Component({
  moduleId: module.id,
  selector: "navbar-cmp",
  templateUrl: "navbar.component.html",
})
export class NavbarComponent implements OnInit {
  private listTitles: any[];
  location: Location;
  private nativeElement: Node;
  private toggleButton;
  private sidebarVisible: boolean;
  private _router: Subscription;
  public open: boolean = false;

  usuario: any;
  cortes: Cortes;
  sucursal: any;
  fecha_apertura: Date;
  public catSucursal: CatSucursales;
  public catUsuario: CatUsuarios;

  @ViewChild("navbar-cmp", { static: false }) button;

  constructor(
    location: Location,
    private element: ElementRef,
    private router: Router,
    private CortesService: CortesService,
    private catSucursalService: CatSucursalService,
    private catUsuariosService: CatUsuariosService,
    private authenticationService: AuthenticationService
  ) {
    this.location = location;
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
  }

  async ngOnInit() {
    await this.authenticationService.getUserByToken();
    this.usuario = this.authenticationService.currentUserValue;
    
    let cortes = new Cortes();
    cortes.idUsuarioCajero = this.usuario.id;
    this.getCortes(cortes);

    this.listTitles = ROUTES.filter((listTitle) => listTitle);

    const navbar: HTMLElement = this.element.nativeElement;
    const body = document.getElementsByTagName("body")[0];
    this.toggleButton = navbar.getElementsByClassName("navbar-toggler")[0];
    this._router = this.router.events
      .filter((event) => event instanceof NavigationEnd)
      .subscribe((event: NavigationEnd) => {
        const $layer = document.getElementsByClassName("close-layer")[0];
        if ($layer) {
          $layer.remove();
        }
      });
  }

  minimizeSidebar() {
    const body = document.getElementsByTagName("body")[0];

    if (misc.sidebar_mini_active === true) {
      body.classList.remove("sidebar-mini");
      misc.sidebar_mini_active = false;
    } else {
      setTimeout(function () {
        body.classList.add("sidebar-mini");

        misc.sidebar_mini_active = true;
      }, 300);
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event("resize"));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);
  }

  isMobileMenu() {
    if (window.outerWidth < 991) {
      return false;
    }
    return true;
  }

  sidebarOpen() {
    var toggleButton = this.toggleButton;
    var html = document.getElementsByTagName("html")[0];
    setTimeout(function () {
      toggleButton.classList.add("toggled");
    }, 500);
    const mainPanel = <HTMLElement>(
      document.getElementsByClassName("main-panel")[0]
    );
    if (window.innerWidth < 991) {
      mainPanel.style.position = "fixed";
    }
    html.classList.add("nav-open");
    this.sidebarVisible = true;
  }
  sidebarClose() {
    var html = document.getElementsByTagName("html")[0];
    this.toggleButton.classList.remove("toggled");
    this.sidebarVisible = false;
    html.classList.remove("nav-open");
    const mainPanel = <HTMLElement>(
      document.getElementsByClassName("main-panel")[0]
    );

    if (window.innerWidth < 991) {
      setTimeout(function () {
        mainPanel.style.position = "";
      }, 500);
    }
  }
  sidebarToggle() {
    // var toggleButton = this.toggleButton;
    // var body = document.getElementsByTagName('body')[0];
    if (this.sidebarVisible == false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
  }

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === "#") {
      titlee = titlee.slice(1);
    }

    if(!this.listTitles) return;

    var children_title, separador = " / ";
    for (var item = 0; item < this.listTitles.length; item++) {
      var parent = this.listTitles[item];
      var children_from_url = titlee.split("/")[2];
      for (var current = 0; current < parent.children.length; current++) {
        if (parent.children[current].path === children_from_url) {
          children_title = parent.children[current].title;
        }
      }
    }
    var father_from_url = titlee.split("/");
    
    switch (father_from_url[1]) {
      case 'liquidacion':
        return "Facturación y Cobranza" + separador + children_title;
        break;
      case 'atencion':
        return "Atención a Usuarios" + separador + children_title;
        break;
      case 'medicionyfacturacion':
        return "Micromedición" + separador + children_title;
        break;
      case 'promociones':
        return "Promociones" + separador + children_title;
        break;
      case 'fiscalizacion':
        return "Fiscalización" + separador + children_title;
        break;
      case 'ingresos':
        return "Tesoreria" + separador + children_title;
        break;
      case 'administracion':
        return "Administración" + separador + children_title;
        break;
      case 'componentes':
        let aux;
        switch (father_from_url[2]) {
          case 'baja-de-cuenta':
            return "Administración De Cuenta";
            break;
          case 'manuales':
            return "Manuales";
            break;
          case 'certificado-no-adeudo':
            aux = "";
            aux = father_from_url[2].split("-");
            return "Cuenta" + separador + aux[0] + " " + aux[1] + " " + aux[2];
            break;
          case 'alta-medidores':
            aux = "";
            aux = father_from_url[2].split("-");
            return "Cuenta" + separador + aux[0] + " " + aux[1];
            break;
          case 'historico-adeudos':
            aux = "";
            aux = father_from_url[2].split("-");
            return "Cuenta" + separador + aux[0] + " " + aux[1];
            break;
          default:
            return "Dashboard";
        }
        break;
      case 'comercializacion':
        return "Comercialización" + separador + father_from_url[2];
        break;
      default:
        return "Dashboard";
    }
  }

  getPath() {
    // console.log(this.location);
    return this.location.prepareExternalUrl(this.location.path());
  }

  async getCortes(Cortes: Cortes) {
    try {
      
      var datoRetorno = await this.CortesService.getBusquedas(
        Cortes
      ).toPromise();

      
      if (datoRetorno.id != 0) {
        this.fecha_apertura = datoRetorno.fechaApertura;
        this.getSucursal(datoRetorno.idSucursal);
      } else {
        var date = new Date(new Date());
        var dayActual = date.getDate().toString().padStart(2, "0");
        var monthIndexActual = (date.getMonth() + 1)
          .toString()
          .padStart(2, "0");
        var yearActual = date.getFullYear();

        var fecha_act = new Date(
          yearActual.toString() +
          "-" +
          monthIndexActual.toString() +
          "-" +
          dayActual.toString()
        );

        this.fecha_apertura = fecha_act;

        this.getUsuario(Cortes.idUsuarioCajero);
      }
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCortes");
    }
  }

  async getUsuario(id: number) {
    try {
      const datoRetorno = await this.catUsuariosService
        .getSingle(id)
        .toPromise();
      this.catUsuario = datoRetorno;
      

      this.getSucursal(datoRetorno.idSucursal);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatSucursal");
    }
  }

  async getSucursal(id: number) {
    try {
      const datoRetorno = await this.catSucursalService
        .getSingle(this.usuario?.idSucursal)
        .toPromise();
      this.catSucursal = datoRetorno; 
      this.sucursal = datoRetorno.descripcion; 
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatSucursal");
    }
  }
}
